export const hu_HU = {
  translation: {
    add_to_cart: "Cikk kosárba helyezése",
    save: "Mentés",
    load: "Cikk betöltése",
    title: "Konfiguráció",
    type_key: "Típus kulcs",
    start: "Indítás",
    generate_document: "Adatlap létrehozása",
    sap_button: "Cikk létrehozása SAP-ban",
    cad_button: "CAD-adatok létrehozása",
    reset_configuration: "Konfiguráció visszaállítása",
    show_additional_information: "További információk megjelenítése",
    sap_title: "SAP",
    close_configuration_button: "Bezárás",
    no_results_found: "Nincs találat",
    load_configuration_dialog: {
      title: "Konfiguráció betöltése – Keresési paraméterek beállítása",
      cancel: "Mégse",
      search: "Keresés",
      start_date: "Létrehozás dátuma-tól",
      end_date: "-ig",
      guid: "GUID",
      material_number: "Anyagszám",
      order_code: "Rendelési kód",
      creator: "Létrehozó",
      description: "Leírás",
      info_artikel: "Információs cikk",
      short_text: "Rövid szöveg",
      version: "Verzió",
      status: "Állapot",
      update_user: "Frissítette",
      createdDate: "Létrehozás dátuma",
      saved_records: "Mentett rekordok",
      back: "Vissza",
      open: "Megnyitás",
      rows_per_page: "Sorok oldalanként:",
    },
    error: {
      ERROR_LOAD_DATA_ERROR:
        "(BETÖLTÉS) sikertelen (helytelen vagy hiányos adatok)",
      ERROR_SAVE_DATA_ERROR:
        "(MENTÉS) sikertelen (helytelen vagy hiányos adatok)",
      ERROR_LOAD_ID: "A betöltendő azonosító nem található",
      ERROR_LOAD_ID_CONFIG: "Hiba a konfigurátortól a projekt betöltésekor",
      ERROR_LOADSTART_CONFIG: "Hiba a konfigurátortól indításkor",
      ERROR_MISSING_VALUES:
        "Általános hibaüzenet, ha a front-end adatok érvényesítése sikertelen",
      ERROR_COOKIE_SERVICE_INITIAL:
        "A cookie-szolgáltatás inicializálása sikertelen",
      ERROR_COOKIE_GENERAL: "Hiba a cookie-szolgáltatásban",
      ERROR_TOKEN_NOT_FOUND: "Token nem található",
      ERROR_ID_BLOCKED:
        "A tétel szerkesztés alatt áll, módosítás nem lehetséges",
      ERROR_DB_SAVE: "Hiba az adatok adatbázisba mentésekor",
      ERROR_LOAD_VALID:
        "A konfiguráció betöltése sikertelen, az adatok érvénytelenek",
      ERROR_NONE_LOAD_ID_FOUND_SAP_CHECK:
        "Azonosító nem található, SAP-ellenőrzés sikertelen",
      ERROR_NONE_LOAD_ID_FOUND_ROWID_FROM_SHOPID:
        "Nem található anyagszám a shop-azonosítóhoz",
      ERROR_DELETE_CONFIGURATION: "Hiba a konfiguráció törlésekor",
      ERROR_DEFINITION_SECRET_JWT: "JWT-definíció hiányzik",
      ERROR_PATH_NOT_DEFINED: "Az útvonal nincs meghatározva",
      ERROR_BACKLINK_URL: "A visszamutató URL nincs meghatározva",
      ERROR_POSITIONDATA_EMPTY: "A pozíció adatai üresek",
      ERROR_SHOP_ID: "Boltazonosító nem található",
      ERROR_CADBOXDATA_EMPTY: "Nem található CAD box adat",
      ERROR_NONE_LOAD_ID_FOUND: "Nem található betöltendő azonosító",
      ERROR_NONE_ACCEPTABLE_ID: "Nem található elfogadható azonosító",
    },
    sap: {
      create_error: "Hiba a létrehozás során",
      create_success: "Sikeresen létrehozva",
    },
    button: {
      save: "Mentés",
      cancel: "Mégse",
    },
  },
};

export default hu_HU;
